import { Model } from "pinia-orm";
import { DocumentType, DocumentStatus } from "@/models/socio-model";

export default class Document extends Model {
  static name = "Document";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
      relatedObjectsList: this.attr([]),
      docType: this.attr(null),
      docStatus: this.attr(null),
      docTypeData: this.belongsTo(DocumentType, "docType"),
      docStatusData: this.belongsTo(DocumentStatus, "docStatus"),
      tagsList: this.attr([]),
      servicesRelatedNameList: this.attr([]),
      originId: this.attr(null),
      oldOriginId: this.attr(null),
      origin: this.attr(null),
      gedProjectId: this.attr(null),
      name: this.attr(null),
      source: this.attr(null),
      ref: this.attr(null),
      datetime: this.attr(null),
      version: this.attr(null),
      metaDatas: this.attr({}),
      bimFileUrl: this.string(""),
      isActive: this.attr(true),
      mimeType: this.attr(null),
      generatedBy: this.attr(null),
    };
  }
}
